<svg [ngClass]="uploading ? 'uploading' : 'loading'" viewBox="40 40 100 100" xmlns="http://www.w3.org/2000/svg">
    <path id="path-1" d="M39.08,81.89 c0,0,50.34-38.39,107.78,0" />
    <path id="path-2" d="M50.34,105.63 c0,0,40.9-33.27,85.25,0.4" />
    <path id="path-3" d="M64.9,126.07 c0,0,28.3-19.57,56.14,0.43" />
</svg>